export default function isObject(object: unknown): object is {} {
  if (object === null) {
    return false;
  }
  return typeof object === 'function' || typeof object === 'object';
}
